import { render } from "./IconUsers.vue?vue&type=template&id=7cfcbf2e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconUsers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cfcbf2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cfcbf2e', __exports__)) {
    api.reload('7cfcbf2e', __exports__)
  }
  
  module.hot.accept("./IconUsers.vue?vue&type=template&id=7cfcbf2e", () => {
    api.rerender('7cfcbf2e', render)
  })

}


export default __exports__